import { toast } from "react-toastify"
import { formatDate } from '@telerik/kendo-intl';
import HttpService from "../../service/httpService";

export const CheckEmptyDate = (value?: Date) => (value === undefined || value === null)
export const CheckBoolean = (value?: boolean) => (value === undefined || value === null)
export const CheckEmptyNumber = (value?: number) => (value === undefined || value === null)

export const localToUTC = (InputDateTime: any, TimeOnly = false, DateOnly = false) => {
    try {
        if (InputDateTime == undefined) {
            return undefined;
        }
        let Day: any = functionpad2(InputDateTime.getDate());
        let Month: any = functionpad2(InputDateTime.getMonth() + 1);
        let Hours: any = functionpad2(InputDateTime.getHours());
        let Minutes: any = functionpad2(InputDateTime.getMinutes());
        if (TimeOnly === true) {
            return `${Hours}:${Minutes}:00`;
        }
        else if (DateOnly === true) {
            return `${InputDateTime.getFullYear()}-${Month}-${Day}`;
        }

        else {
            return `${InputDateTime.getFullYear()}-${Month}-${Day}T${Hours}:${Minutes}:00.000`;
        }
    }
    catch (e) {

        return null;

    }

}
const functionpad2 = (n: any) => {
    return (n < 10 ? '0' : '') + n;
}


// set local date to utc
export const UTCToLocal = (d: string | undefined | Date): Date | undefined => {
    if (d == undefined) return undefined;

    if (typeof d == "string" && d.indexOf("Z") != -1)
        return new Date(d.replace("Z", ""));

    return new Date(d);
}

//export const UTCToLocal = (ReceiveDateTime: any, DateOnly = false, TimeOnly = false) => {
//    if (ReceiveDateTime == null || ReceiveDateTime == undefined) {
//        return '';
//    }
//    //let culture = AppConfig.Get('DateTimeCulture');
//    //if (!!culture)
//    //    culture = 'en-UK';
//    let StartDateObj: any = ReceiveDateTime.split('T')[0];
//    let StartTimeObj: any = ReceiveDateTime.split('T')[1];
//    StartTimeObj = StartTimeObj.split(':00Z')[0];
//    let finalDate: any;
//    let finalTime: any;
//    //StartDateObj = formatDate(
//    //    StartDateObj,
//    //    "dd/MM/yyyy",
//    //   // culture,
//    //    ""
//    //);
//    if (DateOnly == true) {
//        return StartDateObj;
//    }
//    else if (TimeOnly == true) {
//        return StartTimeObj;
//    }
//    else {
//        StartDateObj = StartDateObj.concat(" ");
//        finalDate = StartDateObj.concat(StartTimeObj);
//        return finalDate;

//    }
//}

export const CheckEmpty = (value?: string | Date | boolean | number | undefined | null) => {

    if (value == null || value == undefined || value == "") {
        return true
    }

    if (typeof value === 'string') {
        return value.trim() === ""
    }

    return false;
}

export const IsValidEmail = (value: string) => {

    var filter = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;

    if (value.match(filter)) {
        return true;
    }
    else {
        toast.warning("Invalid Email Id!")
        return false
    }
}

export const IsValidPhoneNo = (value: string, maxLength: any) => {

    var filter = new RegExp(`^([1-9][0-9]{${maxLength - 1}})+$`);
    if (value && value.trim().match(filter) && value.length == maxLength) {
        return true
    }
    else {
        toast.warning("Invalid Phone Number " + value + '. It should be equal to ' + maxLength + ' digits and should not start with 0.')
        return false
    }
}

export const IsValidZipCode = (value: string) => {
    var filter = /^[0-9]+$/;
    if (value.match(filter)) {
        return true
    }
    else {
        toast.warning("Invalid Post Box Number!")
        return false
    }
}

export const IsValidIdnumber = (value: string) => {

    if (value.replace(/[^0-9\.]+/g, '').length == 15) {
        return true
    }
    else {
        toast.warning("Enter valid Id Number! It should be 15 digit number.")
        return false
    }
}

export const IsNotValidDOB = (value: Date) => {
    if (value > new Date()) {
        toast.warning("Invalid Date Of Birth! It can't be future date. ")
        return true
    }
    else
        return false
}

export const GetGUID = () => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        let r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}

export const UTCToLocalDateTime = (d: string | undefined | Date): string | undefined => {
    if (d == undefined) return undefined;
    let date;
    if (typeof d == "string" && d.indexOf("Z") != -1) {
        date = new Date(d.replace("Z", ""));
    } else { date = new Date(d); }

    let hour = date.getHours();
    let minute = date.getMinutes();
    let seconds = date.getSeconds();
    let ampm = hour >= 12 ? 'PM' : 'AM';
    hour = hour % 12;
    hour = hour ? hour : 12;
    //  hour = hour;
    minute = TwoDigitFormat(minute);
    seconds = TwoDigitFormat(seconds);
    let currentDate = TwoDigitFormat(date.getDate()) + '/' + TwoDigitFormat((date.getMonth() + 1)) + '/' + date.getFullYear() + ' '
    return currentDate + TwoDigitFormat(hour % 12) + ":" + minute + ' ' + ampm
}

export const UTCToLocalDate = (d: string | undefined | Date): string | undefined => {
    if (d == undefined) return undefined;
    let date;
    if (typeof d == "string" && d.indexOf("Z") != -1) {
        date = new Date(d.replace("Z", ""));
    } else { date = new Date(d); }

    let hour = date.getHours();
    let minute = date.getMinutes();
    let seconds = date.getSeconds();
    let ampm = hour >= 12 ? 'PM' : 'AM';
    hour = hour % 12;
    hour = hour ? hour : 12;
    //  hour = hour;
    minute = TwoDigitFormat(minute);
    seconds = TwoDigitFormat(seconds);

    let currentDate = TwoDigitFormat(date.getDate()) + '/' + TwoDigitFormat((date.getMonth() + 1)) + '/' + date.getFullYear() + ' '
    return currentDate;

}

const TwoDigitFormat = (n: any) => { return n < 10 ? "0" + n : n }

/**
 * Returns PrimaryKeyEncrypted if found in Url Query String, Router State and Props , wherever founds first
 * Author: Vivek Gupta, Dated: 8-June-2021
 * @param props
 */
export const getPrimaryKeyEncrypted = (props: any): string => {
    var keys = getKeys(props, ["PrimaryKeyEncrypted"]) as any
    return keys && keys.PrimaryKeyEncrypted || '';

}

/**
 * Search and return Keys in Url Query String, Router State and Props, wherever founds first
 * Author: Vivek Gupta, Dated: 8-June-2021
 * @param props
 * @param keys
 */
export const getKeys = (props: any, keys: string[]): {} => {
    var params = new URLSearchParams(props.location.search);
    var response = {};
    keys.forEach((item): void => {
        var key1 = params.get(item) || undefined; // query string
        var key2 = props.location && props.location.state && props.location.state[item] || undefined // router state
        var key3 = props[item] || undefined // props
        response[item] = key1 || key2 || key3;
    });
    return response;
}

export const localToUTCDateTime = (d: Date | undefined): Date | undefined => {
    if (d == undefined) return d;
    // new Date(d - date.getTimezoneOffset() * 60 * 1000)  
    return new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours(), d.getMinutes()));
}

export const GetTimeFromDate = (InputDateTime: any, TimeOnly = false, DateOnly = false) => {
    try {

        let Day: any = functionpad2(InputDateTime.getDate());
        let Month: any = functionpad2(InputDateTime.getMonth() + 1);
        let Hours: any = functionpad2(InputDateTime.getHours());
        let Minutes: any = functionpad2(InputDateTime.getMinutes());
        if (TimeOnly === true) {
            return `${Hours}:${Minutes}:00`;
        }
        else if (DateOnly === true) {
            return `${InputDateTime.getFullYear()}-${Month}-${Day}`;
        }
        else {
            return `${InputDateTime.getFullYear()}-${Month}-${Day}T${Hours}:${Minutes}:00.000`;
        }
    }
    catch (e) {
        if (InputDateTime == undefined || InputDateTime == null) {

            return null;
        }
        else {
            const TimePart = InputDateTime.substring(InputDateTime.indexOf('T') + 1);

            const DateAndTime = TimePart.split(':');
            return `${DateAndTime[0]}:${DateAndTime[1]}:00`;
        }


    }

}
export const SetTimeFromDate = (InputDateTime: string, TimeOnly = false) => {
    try {
        var splitsessionstart = InputDateTime.split(":");
        var date = new Date();
        let Day: any = functionpad2(date.getDate());
        let Month: any = functionpad2(date.getMonth() + 1);
        //let Hours: any = functionpad2(InputDateTime.getHours());
        //let Minutes: any = functionpad2(InputDateTime.getMinutes());
        if (TimeOnly === true) {
            return `${date.getFullYear()}-${Month}-${Day}T${splitsessionstart[0]}:${splitsessionstart[1]}:00.000`;
            //return `${date.getFullYear()}-${splitsessionstart[0]}-${splitsessionstart[1]}`;
            //return `${Hours}:${Minutes}:00`;
        }

        else {
            return `${date.getFullYear()}-${Month}-${Day}`;
        }
    }
    catch (e) {
        return null;
    }

}

export const SetTimeFromDateDefault = () => {
    try {
        //var splitsessionstart = InputDateTime.split(":");
        var date = new Date();
        let Day: any = functionpad2(date.getDate());
        let Month: any = functionpad2(date.getMonth() + 1);
        let Hours: any = (date.getHours());
        let Minutes: any = (date.getMinutes());
        return `${date.getFullYear()}-${Month}-${Day}T${Hours}:${Minutes}:00.000`;
        //return `${date.getFullYear()}-${splitsessionstart[0]}-${splitsessionstart[1]}`;
        //return `${Hours}:${Minutes}:00`;
    }
    catch (e) {
        return null;
    }

}


const toTitleCase = (str) => {

    if (str == 'MRN') {
        return 'MRN';
    }
    else if (str.includes('Tpa') || str.includes('TPA')) {
        var OtherString = str.substr(str.indexOf(' ') + 1);
        return OtherString.replace(
            /\w\S*/g,
            (OtherString) => {
                return OtherString.charAt(0).toUpperCase() + OtherString.substr(1).toLowerCase();
            }
        );
    }
    else {
        return str.replace(
            /\w\S*/g,
            (txt) => {
                return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
            }
        );
    }

}
const toSenteceCase = (str) => {
    const result = str.replace(/([A-Z])/g, " $1");
    const finalResult = result.charAt(0).toUpperCase() + result.slice(1);
    return finalResult;

}
const toNormalCase = (str) => {
    return str;
}

export enum IFormatText {
    TitleCase, ToSenteceCase, ToNormalCase
}

export const formatLabel = (label: string, labelFormat: string) => {
    
    if (!label) return '';

    switch (labelFormat) {
        case 'nocase':
            return label;

        case 'TitleCase':
            return toTitleCase(label);;

        case 'ToSenteceCase':
            return toSenteceCase(label);

        case 'ToNormalCase':
            return toNormalCase(label);

        default:
            if (label.includes('Tpa') || label.includes('TPA')) {
                var stringvalu = toTitleCase(label);
                return 'TPA' + ' ' + stringvalu;
            }
            else {
                var stringvalu = toTitleCase(label);
                return stringvalu;
            }

    }
}

export function base64ToArrayBuffer(base64: string) {
    const binaryString = window.atob(base64); // Comment this if not using base64
    const bytes = new Uint8Array(binaryString.length);
    return bytes.map((byte, i) => binaryString.charCodeAt(i));
}
export const DownloadFile = async (Url: string) => {
    var getBytsdata = await HttpService.get(Url);
    var arrayBuffer = base64ToArrayBuffer(getBytsdata.data.content);
    var blob = new Blob([arrayBuffer], { type: getBytsdata.data.Type });
    var link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.id = 'DownloadFile' + new Date().toISOString();
    var fileName = getBytsdata.data.fileName;
    link.download = fileName;
    link.click();
    link.remove();
}